interface BreakdownTableProps<T> {
  rows: T[];
  columns: Array<{
    key: keyof T | string;
    label: string;
    align?: 'left' | 'right';
    render?: (row: T) => React.ReactNode;
  }>;
  emptyMessage?: string;
}

export function BreakdownTable<T extends Record<string, unknown>>({
  rows,
  columns,
  emptyMessage = 'No data',
}: BreakdownTableProps<T>) {
  if (rows.length === 0) {
    return <p className="text-sm text-muted-foreground">{emptyMessage}</p>;
  }
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border">
            {columns.map((c) => (
              <th
                key={String(c.key)}
                className={`py-2 text-muted-foreground font-medium ${c.align === 'right' ? 'text-right' : 'text-left'}`}
              >
                {c.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={i} className="border-b border-border/50">
              {columns.map((c) => (
                <td
                  key={String(c.key)}
                  className={`py-2 ${c.align === 'right' ? 'text-right font-mono' : 'text-foreground'}`}
                >
                  {c.render ? c.render(row) : String(row[c.key as keyof T] ?? '')}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
